module.exports = __webpack_public_path__ + "img/scene3-3.1e10c377.png";